import * as moment from 'moment';
import { FORMAT, BIDFORMAT } from '../utils/dateOfBirthValidation';
export function getPostInitialValues(recurrenceObjState) {

  let requestDeliveryDate;
  // if (recurrenceObjState.requestDeliveryDate) {
  //   requestDeliveryDate = moment(recurrenceObjState.requestDeliveryDate).format(FORMAT)
  // } else {
  //   requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)
  // }
  requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)

  let startDate = moment(new Date().setDate(new Date().getDate() + 2)).format(BIDFORMAT)
  if (recurrenceObjState.start !== '') {
    startDate = moment(new Date(recurrenceObjState.start).setDate(new Date(recurrenceObjState.start).getDate() + 3)).format(BIDFORMAT)
  }

  let getDate = new Date()
  let nextMonth = getDate.setMonth(getDate.getMonth() + 1);

  let endDate = moment(new Date(nextMonth).setDate(new Date(nextMonth).getDate() + 4)).format(FORMAT)
  return {
    recurranceStartDate: requestDeliveryDate,
    type: '',
    dayOfWeek: recurrenceObjState.dayOfWeek || 'MONDAY',
    interval: recurrenceObjState.interval || 1,
    theEvery: recurrenceObjState.theEvery || 1,
    monthlyRadio: recurrenceObjState.theDayRadio || 'Day',
    noDay: recurrenceObjState.noDay || 1,

    endAfterOccurrences: recurrenceObjState.endAfterOccurrences || 1,
    recurrenceRadio: recurrenceObjState.recurrenceRadio || 'endBy',
    start: startDate,
    recurranceEndDate: endDate,

    index: recurrenceObjState.index || 'FIRST',
    daysdropDown: recurrenceObjState.daysdropDown || 'MONDAY'
  };
}

const VALIDATION_SCHEMA = () => {
}
export { VALIDATION_SCHEMA };